<template>
  <modal-template style="z-index:9999">
    <template #header>
      <div style="color:white;">{{ spacer }}</div>
    </template>
    <template #body>{{ text }}</template>
    <template #footer>
      <div style="width:30%;margin:0 auto;">
        <button class="button" @click="$emit('close', true)">ok</button>
      </div>
    </template>
  </modal-template>
</template>

<script>
import ModalTemplate from '@/components/ModalTemplate'

export default {
  name: 'ApiError',
  props: ['text'],
  emits: ['close'],
  data: function () {
    return {
      spacer: ' '.padEnd(40, 'X'),
    }
  },
  components: {
    ModalTemplate,
  },
}
</script>